import React from "react";
import { useTranslation } from "react-i18next";
import { SchoolDashboard } from "../../common/api";
import { MetricsCard, MetricsRow } from "./MetricsCard";
import { SchoolsTable } from "./SchoolsTable";
import { SectionHeader, SectionTitle } from "./DashboardStyles";

export const DistrictAnalyticsTab = ({
  dashboard,
  navigate,
}: {
  dashboard: SchoolDashboard & { is_at_district_level: true };
  navigate: (string) => void;
}) => {
  const { t } = useTranslation();
  return (
    <>
      <MetricsRow>
        <MetricsCard
          label={t("dashboard_active_users")}
          value={t("intcomma", {
            val: dashboard.student_profile_cnt,
          })}
        />
        <MetricsCard
          label={t("dashboard_lessons_completed")}
          value={t("intcomma", {
            val: dashboard.lessons_completed_cnt,
          })}
        />
        <MetricsCard
          label={t("dashboard_hours_of_tutoring")}
          value={t("intcomma", {
            val: dashboard.time_spent_hours,
          })}
        />
        <MetricsCard
          label={t("dashboard_tutoring_value")}
          value={
            "$" +
            t("intcomma", {
              val: dashboard.tutoring_value_dollars,
            })
          }
        />
      </MetricsRow>
      <SectionHeader className="mt-5">
        <SectionTitle>{t("school_list_schools_title")}</SectionTitle>
      </SectionHeader>
      <SchoolsTable schools={dashboard.schools} navigate={navigate} />
    </>
  );
};
